export default "__VITE_ASSET__6cf4f9bd__"